import React from "react";
import { Link } from "react-router-dom";

function PriceBox(props) {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="col-md-6 col-lg-4 col-xl-4">
      <div className="single-price-box">
        <h3>{props.cartTitle}</h3>
        <span>{props.cartSubtitle}</span>

        <ul className="feature-list">
          {props.features?.map((feature, index) => (
            <li key={index}>
              <i className="fas fa-check" />
              {feature}
            </li>
          ))}
        </ul>

        <div className="pay-btn">
          <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/contact`}>
            Devis gratuit
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PriceBox;